import Nprogress from "nprogress";

const start = Nprogress.start;
const done = Nprogress.done;

let jobs = 0;

Nprogress.start = () => {
	jobs += 1;
	if ( jobs === 1 ) {
		start();
	}
};

Nprogress.done = () => {
	jobs = Math.max( 0, jobs - 1 );
	if ( jobs === 0 ) {
		done();
	}
};

Nprogress.doneAll = done;



// WEBPACK FOOTER //
// ./src/helpers/progress.js